import { Component, OnInit } from '@angular/core';
import { PosthogService } from 'src/app/services/posthog.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  constructor(private readonly posthogService: PosthogService) {}

  ngOnInit(): void {
    this.posthogService.trackNotFoundPageViewed();
  }
}
